import * as actionTypes from "./constants"

const init = {
    orderCards: []
}

const orderReducer = (state = init, action) => {

    switch (action.type) {
        case actionTypes.ADD_ORDER_CARD_LISTEN:
            console.log(action.data)
            return {
                ...state,
                orderCards: action.data
            }
        case actionTypes.GET_ORDER_CARDS_LISTEN:
            return null
        case actionTypes.ADD_ITEM_TO_CART: {
            return {
                ...state,
                orderCards: state.orderCards.concat(action.data)
            }
        }
        case actionTypes.REMOVE_ITEM_FROM_CART_LISTEN:
            const orderArray = state.orderCards
            orderArray.map((e, index) => {
                if (e.id === action.data.id) {
                    orderArray.splice(index, 1)
                }
            })
            return {
                ...state,
                orderCards: orderArray
            }
        default :
            return state
    }
}

export default orderReducer